{
  "eyebrow": "Confirm your plan",
  "title": "Review and configure.",
  "sub": "You can change billing cycle or switch plans anytime from your admin dashboard.",
  "yourPlan": "Your plan",
  "changePlan": "Change plan",
  "billing": "Billing cycle",
  "billingMonthLabel": "Pay monthly",
  "billingMonthDesc": "Flexible. Cancel anytime.",
  "billingYearLabel": "Pay annually",
  "billingYearDesc": "~17% off. Billed once a year.",
  "addons": "Add-ons",
  "addon": {
    "ssec": "Social security (check-in/out@work)",
    "ssecDesc": "Belgium only — automatic Dimona declaration.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Live GPS for company vehicles. +€4 / vehicle / month.",
    "vehicles": "Vehicles",
    "projectAddon": "Project management add-on",
    "projectAddonDesc": "Unlock the Time Pro project management features (additional work, scheduling, subcontractor management)."
  },
  "employees": {
    "title": "How many employees?",
    "active": "active users",
    "popular": "Most teams pick {{n}}"
  },
  "estimate": "Estimated monthly cost",
  "estimateNote": "Excluding VAT. Per-user fees billed based on active employees.",
  "estimateUnavailable": "Price catalog unavailable. Retry to load the latest pricing."
}
